<template>
    <div>
        <Row :gutter="16">
            <i-col :xs="24" :md="12" :lg="8"
                   v-for="(usuario, index) in usuarios_ordenados" :key="index">
                <router-link :to="`/usuario/${usuario.id_pessoa}`"
                             :class="`card-user ${!usuario.ativo ? 'inativo': ''}`">
                    <Card :bordered="false" dis-hover shadow :style="{marginBottom:'16px'}">
                        <Avatar size="large"
                                :style="{marginRight:'16px', background: (usuario.ativo ? cores[Math.floor(Math.random() * cores.length)] : null) }">
                            {{usuario.nome.charAt(0)}}
                        </Avatar>
                        {{ usuario.nome }}
                        <a href="#" class="more-option" @click.prevent="alterar(usuario.id_pessoa, 1 - usuario.ativo)">
                            <Icon :type="usuario.ativo ? 'ios-trash-outline' : 'ios-refresh'" size="30"
                                  :style="{float: 'right'}"/>
                        </a>
                    </Card>
                </router-link>
            </i-col>
        </Row>
        <div class="floating-btn">
            <router-link to="/usuario">
                <i-button type="primary" shape="circle" icon="md-add"></i-button>
            </router-link>
        </div>
    </div>
</template>

<script>
    const _ = require("lodash");
    export default {
        data() {
            return {
                usuarios: [],
                cores: [
                    "#e26304",
                    "#3255d2",
                    "#c74974",
                    "#7c36d1",
                    "#f86874",
                    "#0e99cf",
                    "#34b46a",
                    "#23c1d9",
                    "#ffc124"
                ]
            };
        },
        created() {
            this.getUsuarios();
        },
        computed: {
            usuarios_ordenados() {
                return _.orderBy(this.usuarios, ["ativo", "nome"], ["desc", "asc"]);
            }
        },
        methods: {
            /**
             * Lista os usuários cadastrados
             */
            async getUsuarios() {
                try {
                    const URI = `pessoa`;
                    const {data} = await this.$axios.get(URI);
                    this.usuarios = data;
                } catch (ex) {
                    console.warn(ex);
                }
            },
            /**
             * Ativa ou inativa o cadastro do usuário
             */
            async alterar(id_pessoa, ativo) {
                const idx = _.findIndex(
                    this.usuarios,
                    o => o.id_pessoa == id_pessoa
                );
                this.usuarios[idx].ativo = ativo;
                try {
                    const URI = `pessoa`;
                    await this.$axios.put(
                        `${URI}/${id_pessoa}`,
                        {ativo}
                    );
                } catch (ex) {
                    console.warn(ex);
                    this.getUsuarios();
                }
            }
        }
    };
</script>

<style>
    .card-user {
        color: #2d3e4f;
    }

    .card-user.inativo {
        color: #909090;
    }

    .card-user .more-option {
        display: none;
    }

    .card-user:hover .more-option {
        display: inline;
    }
</style>
